import "./index.scss";
import React, { ReactNode } from "react";
import cn from "classnames";

type OpenBannerBackgroundTheme =
  | "base-primary"
  | "base-secondary"
  | "base-tertiary"
  | "brand-primary"
  | "brand-secondary"
  | "inverse-base-primary";

type WrapperSize = "full" | "lg" | "md" | "sm";

export type OpenBannerProps = {
  topEditorial?: ReactNode;
  ctaList?: ReactNode;
  bannerImage?: ReactNode;
  tagGroup?: ReactNode;
  bottomEditorial?: ReactNode;
  backgroundTheme: OpenBannerBackgroundTheme;
  internalWrapper: WrapperSize;
  isMain: boolean;
};

const OpenBanner = ({
  topEditorial,
  ctaList,
  bannerImage,
  tagGroup,
  bottomEditorial,
  backgroundTheme,
  internalWrapper,
  isMain,
}: OpenBannerProps) => (
  <div className="open-banner">
    <div
      className={cn("open-banner__wrapper", {
        "open-banner__wrapper--main": isMain,
      })}
      style={{
        background: `var(--background-${backgroundTheme})`,
      }}
    >
      <div
        className={`open-banner__content wrapContentV2-xl-${internalWrapper}`}
      >
        {topEditorial}
        {ctaList}
        {bannerImage}
        {tagGroup}
        {bottomEditorial}
      </div>
    </div>
  </div>
);

export default OpenBanner;
